module.exports = __webpack_public_path__ + "assets/img/1039c5cdbcb8a85636f8bbbdb30c5a84.png";